/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { eapiakvInjectableRxStompConfig } from './services/base-classes/eapiakv-injectable-rx-stomp-config';
import { eapiakvRxStompConfig } from './services/smq-eapiakv-config';
import { SMQAdminService } from './services/smq-admin-service';
import { SMQGuestService } from './services/smq-guest-service';
import { eapiakvRxStompService } from './services/base-classes/eapiakv-rx-stomp-services';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: eapiakvInjectableRxStompConfig, 
      useValue: eapiakvRxStompConfig,
    },
    {
      provide: eapiakvRxStompService,
      useFactory: (eapiakvInjectableRxStompConfig:eapiakvInjectableRxStompConfig) =>
        new eapiakvRxStompService(eapiakvInjectableRxStompConfig),
     deps: [eapiakvInjectableRxStompConfig],
    },
    SMQAdminService, 
    SMQGuestService
  ]
})
export class AppModule {
}
